import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress Google Translate DOM manipulation errors globally
const originalError = console.error;
console.error = (...args) => {
  if (args[0]?.includes?.('removeChild') || 
      args[0]?.includes?.('NotFoundError') ||
      args[0]?.includes?.('The node to be removed')) {
    return;
  }
  originalError.apply(console, args);
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
